// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatsMain {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: calc(100vh - 92px);
    gap: 24px;
    align-items: left;
    justify-content: left;
    padding: 40px 15px 0 15px;
}

.chatsTitle {
    font-size: 32px;
    font-weight: 700;
    line-height: 38.4px;
    text-align: left;
    color: #4B2D10;
}

.chatsEmptyColumn {
    display: flex;
    flex-direction: column;
    gap: 80px;
    width: 100%;
    height: calc(100vh - 193px);
    align-items: center;
    justify-content: flex-end;
}

.chatsEmptyImage {
    width: 272.42px;
    height: 407.62px;
}

.chatsEmptyText {
    color: #8E3B00;
    font-size: 19.27px;
    font-weight: 700;
    line-height: 23.12px;
    text-align: left;
    -webkit-user-select: none;
            user-select: none;
}

.chatsEmptyTextBlock {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.chatsEmptyTextBlock p {
    width: 150px;
    position: absolute;
    top: 45%;
    transform: translateY(-50%);
}

.chatsColumnItems {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Chats/Chats.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf","sourcesContent":[".chatsMain {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: calc(100vh - 92px);\n    gap: 24px;\n    align-items: left;\n    justify-content: left;\n    padding: 40px 15px 0 15px;\n}\n\n.chatsTitle {\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 38.4px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.chatsEmptyColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 80px;\n    width: 100%;\n    height: calc(100vh - 193px);\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.chatsEmptyImage {\n    width: 272.42px;\n    height: 407.62px;\n}\n\n.chatsEmptyText {\n    color: #8E3B00;\n    font-size: 19.27px;\n    font-weight: 700;\n    line-height: 23.12px;\n    text-align: left;\n    user-select: none;\n}\n\n.chatsEmptyTextBlock {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.chatsEmptyTextBlock p {\n    width: 150px;\n    position: absolute;\n    top: 45%;\n    transform: translateY(-50%);\n}\n\n.chatsColumnItems {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
